import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const mmtc_sell_responseApi = createAsyncThunk("mmtc_sell_response", async ({ startDate = null, endDate = null }) => {
  const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
  const response = await axiosInstance.get("/mmtc_sell_response",{ params });
  return response.data;
});

const mmtc_sell_responseSlice = createSlice({
  name: "mmtc_sell_response",
  initialState: {
    mmtc_sell_response: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(mmtc_sell_responseApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(mmtc_sell_responseApi.fulfilled, (state, action) => {
        state.mmtc_sell_response = action.payload;
        state.loading = false;
      })
      .addCase(mmtc_sell_responseApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default mmtc_sell_responseSlice.reducer;
